/** @jsx jsx */

import React, { Fragment as _, useRef, useLayoutEffect } from 'react';
import { css, jsx } from '@emotion/core';
import { values, colors } from 'styles/variables';
import useImageLoader from 'hooks/useImageLoader';
import LoadingSpinner from 'components/UI/LoadingSpinner';

const { headerHeight } = values;
const { lPink, lGrey4 } = colors;

const Circle = ({
  id,
  src,
  fit = 'cover',
  cachedSrc,
  children,
}: {
  id: string | number;
  src: string;
  fit?: string;
  cachedSrc?: any;
  children?: any;
}) => {
  const imgLoadedState = useImageLoader(src);
  const circle: any = useRef(null);

  useLayoutEffect(() => {
    if (!circle.current) {
      return;
    }

    const checkSize = () => {
      if (!circle.current) return;

      let { width, height } = circle.current.getBoundingClientRect();
      // width
      circle.current.style.maxWidth = `${height}px`;

      return [width, height].includes(0) ? false : width === height;
    };

    const tick = setInterval(() => {
      if (checkSize()) {
        clearInterval(tick);
      }
    }, 1000 / 60);

    // onScrollEnds(() => {
    //   console.log('checking for circle size');
    //   checkSize();
    // });

    window.addEventListener('resize', checkSize);

    imgLoadedState === 2 && cachedSrc(id, src);

    return () => {
      window.removeEventListener('resize', checkSize);
    };
  }, [imgLoadedState]);
  //

  return imgLoadedState === 1 ? (
    <LoadingSpinner />
  ) : (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      `}
    >
      <div
        ref={circle}
        className={src === cachedSrc(id) ? '' : 'fader_-5s'}
        css={css`
          flex-shrink: 0;
          width: 100%;
          height: 100%;
          max-height: 50vh;
          border-radius: 50%;
          background: url('${src}') no-repeat, ${lGrey4};
          background-size: ${fit};
          background-position: center;
          pointer-events: none;
          overflow: hidden;

          &::before {
            display: block;
            content: '';
            padding-top: 100%;
          }
          
          img {
            width: 100%;
            max-height: 50vh;
            opacity: 0;
          }
          
        `}
      >
        {children}
      </div>
    </div>
  );
};

export default Circle;
